import React from 'react';

import PropTypes from 'prop-types';
import {
  Subtitle,
  Text,
  WhiteTile
} from 'src/StyledComponents';

import {
  Checkbox,
  GreenTick
} from 'src/Components/Common';

export const TermsAndConditions = (props) => {

  const termsAndConditionURL = 'https://www.vodacom.co.za/vodacom/terms/fibre/vodacom-fibre';

  const miniAppProactiveSales = !!(window.isFtthMA);

  return (

    <>
      <WhiteTile automationid="SalesLeads_Div_TermsConditions_111">
        <div className="review-order__terms-conditions-title">

          <GreenTick />
          <Subtitle style={{ marginTop: 0, marginLeft: '1rem' }}>
            Terms and Conditions
          </Subtitle>
        </div>

        <div className="review-order__terms-conditions">

          <Checkbox
            onChange={props.onChange}
            checked={props.checked}
            automatioIdAttr="NewCustomer_Terms"
          />

          <Text style={{ marginLeft: '1rem' }}>
            I understand and accept that this is a valid and binding agreement
            in respect of the equipment and/or service concluded between myself
            and Vodacom as per the&nbsp;
            {!miniAppProactiveSales ?

              <a href={termsAndConditionURL} target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
              :
              <span className='quote-terms-miniapp' onClick={props.openTandC}>Terms and Conditions</span>
            }
          </Text>
        </div>
      </WhiteTile>
    </>
  );
};

TermsAndConditions.propTypes = {
  openTandC: PropTypes.func,
  onChange: PropTypes.func,
  checked: PropTypes.bool
};
